<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <!-- <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">MENTOR COURSES</h4>
                <div style="margin-left:700px;">
                    <button type="button" class="btn btn-block btn-primary" data-toggle="modal" data-target="#myModal"
                        >Create Technical</button>
                </div>
                <div >
                    <button type="button" class="btn btn-block btn-primary" data-toggle="modal" data-target="#myModal1"
                        >Create Motivational</button>
                </div>
            </div>
        </div> -->
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center flex-wrap">
                <h4 class="font-weight-bold text-dark py mb-2 flex-grow-1">My Courses</h4>
                <div class="d-flex flex-wrap">
                    <div class="mr-2 mb-2">
                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal" (click)="create()">
                            Create Technical
                        </button>
                    </div>
                    <div class="mb-2">
                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal1" (click)="create()">
                            Create Career Guidance
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                          
                            <th>Description</th>
                            <th>Type Of Course</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Status</th>
                            <th>Edit</th>
                            <th>Show</th>
                        </tr>
                    </thead>


                    <tbody>
                        <tr *ngFor="let coursedata of coursedatas">
                            <td style="min-width: 20px;">
                                {{coursedata.course_name}}
                            </td>

                           
                            <td style="min-width: 20px;">
                                {{coursedata.course_des

                                }}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.typeofcourse
                                }}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.course_date
                                | date: 'dd-MM-yyyy'}}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.course_time
                                }}
                            </td>
                            <td> <button 
                                [ngClass]="coursedata.allow_course === '1' ? 'btn btn-success': (coursedata.allow_course === '0' ? 'btn btn-danger' : 'btn btn-info')">
                                {{ coursedata.allow_course === '1' ? 'Approved' : (coursedata.allow_course === '0' ? 'Rejected' : 'Open') }}
                            </button></td>
                            <td>
                                <ng-container *ngIf="coursedata.typeofcourse == 'Technical'; else motivationalBlock">
                                  <a data-toggle="modal" data-target="#myModal" class="btn btn-primary btn-circle btn-sm" (click)="get_coursebyid(coursedata.id,'UPDATE')">
                                    <i class="fas fa-check"></i>
                                  </a>
                                </ng-container>
                                <ng-template #motivationalBlock>
                                  <a data-toggle="modal" data-target="#myModal1" class="btn btn-primary btn-circle btn-sm" (click)="get_coursebyid(coursedata.id,'UPDATE')">
                                    <i class="fas fa-check"></i>
                                  </a>
                                </ng-template>
                              </td>
                              <td>
                                <ng-container *ngIf="coursedata.typeofcourse == 'Technical'; else motivationalBlock1">
                                  <a data-toggle="modal" data-target="#myModal" class="btn btn-primary btn-circle btn-sm" (click)="get_coursebyid(coursedata.id,'SHOW')">
                                    <i class="fas fa-flag"></i>
                                  </a>
                                </ng-container>
                                <ng-template #motivationalBlock1>
                                  <a data-toggle="modal" data-target="#myModal1" class="btn btn-primary btn-circle btn-sm" (click)="get_coursebyid(coursedata.id,'SHOW')">
                                    <i class="fas fa-flag"></i>
                                  </a>
                                </ng-template>
                              </td>
                            
                          
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        
        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                   
                    <div class="card">
                        <div  *ngIf="show; else editCreateBlock" class="card-header show-header ">
                            <h3 class="card-title">{{ 'SHOW TECHNICAL' }}</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>
                        <ng-template #editCreateBlock>
                        <div class="card-header show-header ">
                            <h3 class="card-title">{{ isEditModetech ? 'EDIT COURSE' : 'CREATE COURSE' }}</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>
                    </ng-template>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='mentorcourse' 
                                (ngSubmit)="isEditModetech ? posteditData(mentorcourse) : postdata(mentorcourse) " autocomplete="off">
                                <div class="form-group row">
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Course Name</label>
                                        <span
                                            class="required">*</span>  
                                        <input type="text" class="form-control" formControlName="course_name"
                                            placeholder="Enter Course Name" /> 
                                            <div style="color:red;"
                                            *ngIf="mentorcourse.get('course_name').touched &&  mentorcourse.get('course_name').value==''"
                                                class="invalid-msg">Please fill the field </div> 
                                                <!---<div *ngIf="mentorcourse.get('session_link').hasError('invalidLink')"  class="invalid-msg">Invalid Session Link.</div> -->
                                            </div>
                                    <div class="form-group col-md-6">
                                        <label>Subject</label><span class="required "> *</span>
                                        <!-- <input type="text" class="form-control" formControlName="course_topic"
                                        placeholder="Enter Subject" /> 
                                        <div *ngIf="mentorcourse.get('course_topic').touched &&  mentorcourse.get('course_topic').value ==''"
                                        class="invalid-msg">Please fill the field </div> -->
                                        <select class="form-control" formControlName="course_topic"  placeholder="Select Subject">
                                            <option selected>Select Subject</option>
                                            <option>Civil</option>
                                            <option>Mechanical</option>
                                            <option>Computer</option>
                                            <option>IT</option>
                                                <option>Maths</option>
                                                <option>Physics</option>
                                                <option>Chemistry</option>
                                                <option>Botany</option>
                                                <option>Zoology</option>
                                                <option>Commerce</option>
                                                <option>Accountancy</option>
                                                <option>Economics</option>
                                                <option>History</option>
                                                <option>Civics</option>
                                                <option>Geography</option>
                                                <option>Aptitude</option>
                                                <option>General knowledge</option>
                                                <option>Electrical and Electronics</option>
                                                <option>Electronics and communication</option>
                                                <option>Others</option>
                                        </select>
                                        <div *ngIf="mentorcourse.get('course_topic').touched &&  mentorcourse.get('course_topic').value ==''"
                                        class="invalid-msg">Please fill the field </div>
                                
                                </div>
                                    <div class="row" style="display:none">
                                        <input type="number" formControlName="user_id" />
                                    </div>
                                    <div class="form-group col-md-12">
                                        <label class="form-label">Course Description</label>
                                        <span
                                            class="required"></span>  
                                        <textarea type="text" class="form-control" formControlName="course_des"
                                            placeholder="Enter Course Description" ></textarea> 
                                        <!-- <div *ngIf="mentorcourse.get('session_link').touched &&  mentorcourse.get('session_link').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                            <div *ngIf="mentorcourse.get('session_link').hasError('invalidLink')"  class="invalid-msg">Invalid Session Link.</div> -->
    </div>
                                   
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="form-label">Mode of Course <span class="required">*</span></label><br>
                                    <div>
                                        <label class="mr-3">
                                            <input type="radio" formControlName="mode" value="Online" /> Online
                                        </label>
                                        <label>
                                            <input type="radio" formControlName="mode" value="Offline" /> Offline
                                        </label>
                                    </div>
                                    <div *ngIf="mentorcourse.get('mode').touched && mentorcourse.get('mode').value ==''" class="invalid-msg">
                                        Please select a mode
                                    </div>
                                </div>
                              
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Course Date</label><span
                                            class="required">*</span>
                                        <input type="date" class="form-control" formControlName="course_date"
                                            placeholder="Enter Course Date" [min]="getCurrentDates()">
                                            <div *ngIf="mentorcourse.get('course_date').touched &&  mentorcourse.get('course_date').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Course Time</label><span class="required">*</span>
                                        <input type="time" class="form-control" formControlName="course_time"
                                            placeholder="Enter Course Time" [min]="getCurrentDates()">
                                            <div *ngIf="mentorcourse.get('course_time').touched &&  mentorcourse.get('course_time').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                   
                                   
                                   
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">

                                    <label class="form-label">
                                        Online Meeting Link:
                                        <a href="https://meet.google.com/landing" target="_blank">Google Meet</a>/
                                        <a href="https://app.zoom.us/wc" target="_blank">Zoom Meet</a>
                                        <span class="required"> *</span>
                                    </label>
                                    <input type="text" class="form-control" formControlName="session_link" placeholder="Enter Meet Link" />
                                    <div *ngIf="mentorcourse.get('session_link').touched && mentorcourse.get('session_link').value == ''" class="invalid-msg">
                                        Please fill the field
                                    </div>
                                    </div>

                                       <div class="col-md-6" *ngIf="!imageshow">
                                    <label>Photo <span class="required">*</span></label>
                                    <input type="file" formControlName="image" id="file"  class="form-control" (change)="selectFiles($event)" />
                                    <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format jpeg, jpg, png</p>
                                
                                    <!-- Display the selected image or a default image if none is selected -->
                                    <!-- <img [src]="imageSrc || 'images/course.jpg'" 
                                         style="width:100px;height:100px;display:block;margin-top:10px;" 
                                         alt="Course Image"/> -->
                                         
                                    <div style="color:red;" 
                                         *ngIf="mentorcourse.get('image')?.touched && (mentorcourse.get('image')?.hasError('required') || mentorcourse.get('image')?.hasError('imageSizeExceeded'))">
                                        Please upload a valid image 
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="imageshow">
                                    <label>Photo <span class="required">*</span></label>
                                    <img [src]="imageSrc" style="width:50px;height:50px;display:block;margin-top:10px;" alt="Course Image"/>

                                  
                                </div>
                                    <!-- Uncomment if you want to show invalid link message -->
                                    <!-- <div *ngIf="mentorcourse.get('session_link').hasError('invalidLink')" class="invalid-msg">Invalid Session Link.</div> -->
                                </div>
                             
                                
                              
                                <div class="form-group">
                                    <div>
                                        <label>Comments</label> 
                                        <textarea type="text" class="form-control" formControlName="comments"
                                            placeholder=" Enter Comments"></textarea>
                                             <!-- <div *ngIf="mentorcourse.get('comments').touched &&  mentorcourse.get('comments').value==''"
                                            class="invalid-msg">Please fill the field </div> -->
                                           </div>
                                </div>

                                <div *ngIf ="!show" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn btn-block" [disabled]="mentorcourse.invalid">{{ isEditModetech ? 'Update' : 'Submit' }}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="myModal1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">
                        <div  *ngIf="show; else editCreateBlock1" class="card-header show-header ">
                            <h3 class="card-title">{{ 'SHOW CAREER GUIDANCE ' }}</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>
                        <ng-template #editCreateBlock1>
                           
                        <div class="card-header show-header ">
                            <h3 class="card-title">{{ isEditModeMove ? 'EDIT CAREER GUIDANCE' : 'CREATE CAREER GUIDANCE' }}</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>
                    
                    </ng-template>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='mentorcourse_motivational'                                
                                (ngSubmit)=  "isEditModeMove ? posteditData(mentorcourse_motivational) : postdata_motivation(mentorcourse_motivational) " autocomplete="off">
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Topic </label><span class="required "> *</span>
                                           <input type="text" class="form-control" formControlName="course_name"
                                           placeholder="Enter Topic">
                                         <div *ngIf="mentorcourse_motivational.get('course_name').touched &&  mentorcourse_motivational.get('course_name').value ==''"
                                            class="invalid-msg">Please fill the field </div> 
                                    </div>
                                    <div class="row" style="display:none">
                                        <input type="number" formControlName="user_id" />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Description</label>
                                        <span
                                            class="required"></span>  
                                        <textarea type="text" class="form-control" formControlName="course_des"
                                            placeholder="Enter Description" ></textarea> 
                                        <div *ngIf="mentorcourse_motivational.get('course_des').touched &&  mentorcourse_motivational.get('course_des').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                            <div *ngIf="mentorcourse_motivational.get('course_des').hasError('invalidLink')"  class="invalid-msg">Invalid Session Link.</div> 
    </div>
                                
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="form-label">Mode of Course <span class="required">*</span></label><br>
                                    <div>
                                        <label class="mr-3">
                                            <input type="radio" formControlName="mode" value="Online" aria-selected="true"/> Online
                                        </label>
                                        <label>
                                            <input type="radio" formControlName="mode" value="Offline" /> Offline
                                        </label>
                                    </div>
                                    <div *ngIf="mentorcourse_motivational.get('mode').touched && mentorcourse_motivational.get('mode').value ==''" class="invalid-msg">
                                        Please select a mode
                                    </div>
                                </div>
                               
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Course Date</label><span
                                            class="required">*</span>
                                        <input type="date" class="form-control" formControlName="course_date"
                                            placeholder="Enter Course Date" [min]="getCurrentDates()">
                                        <div *ngIf="mentorcourse_motivational.get('course_date').touched &&  mentorcourse_motivational.get('course_date').value==''"
                                            class="invalid-msg">Please fill the field </div> 
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Course Time</label><span class="required">*</span>
                                        <input type="time" class="form-control" formControlName="course_time"
                                            placeholder="Enter Course Time" [min]="getCurrentDates()">
                                        <div *ngIf="mentorcourse_motivational.get('course_time').touched &&  mentorcourse_motivational.get('course_time').value==''"
                                            class="invalid-msg">Please fill the field </div> 
                                    </div>
                                   
                                   

                                </div>
                                <div class="form-group row">
                                    <div class="form-group col-md-6">
                                        <label class="form-label">
                                            Online Meeting Link:
                                            <a href="https://meet.google.com/landing" target="_blank">Google Meet</a>/
                                            <a href="https://app.zoom.us/wc" target="_blank">Zoom Meet</a>
                                            <span class="required"> *</span>
                                        </label>
                                        <input type="text" class="form-control" formControlName="session_link" placeholder="Enter Online Meeting link" /> 
                                        <div *ngIf="mentorcourse_motivational.get('session_link').touched && mentorcourse_motivational.get('session_link').value==''"
                                            class="invalid-msg">Please fill the field </div> 
                                        <!-- <div *ngIf="mentorcourse_motivational.get('session_link').hasError('invalidLink')" class="invalid-msg">Invalid Session Link.</div> -->
                                    </div>

                                    <div class="col-md-6" *ngIf="!imageshow">
                                        <label>Photo <span class="required">*</span></label>
                                        <input type="file" formControlName="image" id="file"  class="form-control" (change)="selectFiles($event)" />
                                        <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format jpeg, jpg, png</p>
                                    
                                        <!-- Display the selected image or a default image if none is selected -->
                                        <!-- <img [src]="imageSrc || 'images/course.jpg'" 
                                             style="width:100px;height:100px;display:block;margin-top:10px;" 
                                             alt="Course Image"/> -->
                                             
                                        <div style="color:red;" 
                                             *ngIf="mentorcourse.get('image')?.touched && (mentorcourse.get('image')?.hasError('required') || mentorcourse.get('image')?.hasError('imageSizeExceeded'))">
                                            Please upload a valid image 
                                        </div>
                                    </div>

                                    <div class="col-md-6" *ngIf="imageshow">
                                        <label>Photo <span class="required">*</span></label>
                                        <img [src]="imageSrc" style="width:50px;height:50px;display:block;margin-top:10px;" alt="Course Image"/>
    
                                      
                                    </div>
                                    
</div>
                                <div class="form-group">
                                    <div>
                                        <label>Comments</label> 
                                        <textarea type="text" class="form-control" formControlName="comments"
                                            placeholder="Comments"></textarea>
                                             <!-- <div *ngIf="mentorcourse_motivational.get('comments').touched &&  mentorcourse_motivational.get('comments').value==''"
                                            class="invalid-msg">Please fill the field </div> -->
                                           </div>
                                </div>

                                <div *ngIf="!show" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn btn-block" [disabled]="mentorcourse_motivational.invalid">{{ isEditModeMove ? 'Update' : 'Submit' }}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>